<!--
 * @Author: 谷文 guwenwen@dongfangfuli.com
 * @Date: 2023-06-27 14:56:23
 * @LastEditors: 谷文 guwenwen@dongfangfuli.com
 * @LastEditTime: 2023-08-04 11:04:18
 * @FilePath: /fore-trade-birthday-h5/Users/guwen/Desktop/gitCode/dffl-mall-h5/src/components/HomeBusTag.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div>
    <!-- 运营标签位组件 -->
    <template v-if="businessFrontTags && businessFrontTags.length > 0">
      <CapsuleTabs :value="businessFrontTagId" :tabList="businessFrontTags | formatBusiness"
        @handChangeCapsule="handChangeCapsule"></CapsuleTabs>
    </template>
  </div>
</template>

<script>
import { mapState } from "vuex"
import CapsuleTabs from "./capsule-tabs"
import { setBusTagFronSession } from "../utils/index"
import {  gioClickHandle } from "../utils";

export default {
  components: {
    CapsuleTabs
  },
  filters: {
    formatBusiness(list) {
      return list.map((bus) => ({ key: bus.businessFrontTagId, title: bus.businessFrontTagName })) || []
    },
  },
  props: {
    defParams: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
     
    }
  },
  computed: {
    ...mapState({
      businessFrontTags: (state) => state.businessFrontTags,
      businessFrontTagId: (state) => state.businessFrontTagId,
    }),
  },
  methods: {
    handChangeCapsule(value, item, obj) {
      gioClickHandle("DF_elementClick", {
        df_searchKeyword: this.defParams.key || "",
        df_contentTitle: obj.title,
        df_modulename: "标签筛选",
        df_elementname: "运营标签",
        df_status: value ? '选中' : '取消选中',
        df_pagename: "搜索结果页",
      })

      // this.$store.commit("setBusTagChange", value);
      setBusTagFronSession(value)
      this.$store.commit("setbusinessFrontTagId", item.key);
      // 存储埋点
      this.$store.commit("setAllQuery",{...this.allQuery,businessFrontTagName: item.title});
      this.$emit("handlerUpdata", {
        // businessFrontTagId: item.key
      }, 1)
    }
  }
}
</script>
